const initialState = {
	error: null,
};

export function errorReducer(state = initialState, action) {
	const { error, payload } = action;

	if (error) {
		return {
			error: payload,
		};
	} else if (action.type === "RESET_CME") return initialState;

	return state;
}
